import { FieldValidation } from '@rjsf/utils';
import { AzureResourceGroup } from './useAzureResourceGroups';

export const validateAzureResourceGroup = (
  resourceGroup: AzureResourceGroup | undefined,
  validation: FieldValidation,
) => {
  if (resourceGroup === undefined) return;
  if (!resourceGroup?.id || !resourceGroup?.name || !resourceGroup?.location) {
    validation.addError('Please select a valid Azure resource group');
  }
};
